import React from 'react';

const contextDefaultValues = {
  currentPage: 1,
  datasource: {},
  onRowClick: () => {},
  perPage: 20,
  perPageOptions: [],
  searchTerms: '',
  selectAllChecked: false,
  setCurrentPage: () => {},
  setPageSize: () => {},
  setQuickFilter: () => {},
  toggleSelectAll: () => {},
  updateDatasource: () => {}
};

const DataTableContext = React.createContext(contextDefaultValues);

export default DataTableContext;
